<template>
  <div class="widget-heading pb-0 d-block">
    <div class="row">

      <div class="col-md-12 col-lg-10">
        <h4 class="d-inline-block h4" style="line-height: 1.4">
          Ustawienia:
        </h4>
      </div>

      <!-- Duży ekran -->
      <div class="col-md-12 btn-group d-none d-md-flex">
        <Link :href="route('kadry.terminy.typy')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('kadry.terminy.typy') }">Typy terminów</Link>
        <Link :href="route('kadry.urlopy.typy')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('kadry.urlopy.typy') }">Typy dni wolnych</Link>
        <Link :href="route('kadry.typ_umowy.lista')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('kadry.typ_umowy.lista') }">Rodzaje umów</Link>
        <Link :href="route('kadry.etaty.typy')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('kadry.etaty.typy') }">Rodzaje etatów</Link>
        <Link :href="route('kadry.typy_godzin.lista')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('kadry.typy_godzin.lista') }">Rodzaje godzin</Link>
        <Link :href="route('kadry.settings')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('kadry.settings') }">Inne ustawienia</Link>
        <Link :href="route('kadry.dni.wolne')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('kadry.dni.wolne') }">Dni wolne</Link>
        <Link :href="route('kadry.stawki')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('kadry.stawki') }">Stawki</Link>     </div>

      <!-- Mały ekran -->
      <div class="col-12 d-md-none">
        <div class="dropdown">
		  <button class="btn btn-outline-primary dropdown-toggle w-100 d-flex align-items-center justify-content-between" type="button" @click="toggleDropdown">
		  {{ activeLabel }}
		  <i class="bi bi-list ms-2"></i>
		  </button>
          <div class="dropdown-menu w-100" :class="{ show: isDropdownOpen }">
            <Link :href="route('kadry.terminy.typy')" class="dropdown-item" :class="{ 'active': isRouteActive('kadry.terminy.typy') }">Typy terminów</Link>
            <Link :href="route('kadry.urlopy.typy')" class="dropdown-item" :class="{ 'active': isRouteActive('kadry.urlopy.typy') }">Typy dni wolnych</Link>
            <Link :href="route('kadry.typ_umowy.lista')" class="dropdown-item" :class="{ 'active': isRouteActive('kadry.typ_umowy.lista') }">Rodzaje umów</Link>
            <Link :href="route('kadry.etaty.typy')" class="dropdown-item" :class="{ 'active': isRouteActive('kadry.etaty.typy') }">Rodzaje etatów</Link>
            <Link :href="route('kadry.typy_godzin.lista')" class="dropdown-item" :class="{ 'active': isRouteActive('kadry.typy_godzin.lista') }">Rodzaje godzin</Link>
            <Link :href="route('kadry.settings')" class="dropdown-item" :class="{ 'active': isRouteActive('kadry.settings') }">Inne ustawienia</Link>
            <Link :href="route('kadry.dni.wolne')" class="dropdown-item" :class="{ 'active': isRouteActive('kadry.dni.wolne') }">Dni wolne</Link>
            <Link :href="route('kadry.stawki')" class="dropdown-item" :class="{ 'active': isRouteActive('kadry.stawki') }">Stawki</Link>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";

export default {
  setup() {
    const isDropdownOpen = ref(false);

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const isRouteActive = (routeName) => {
      return route().current(routeName);
    };

    // mapowanie trasa -> etykieta
    const labels = {
      "kadry.terminy.typy": "Typy terminów",
      "kadry.urlopy.typy": "Typy dni wolnych",
      "kadry.typ_umowy.lista": "Rodzaje umów",
      "kadry.etaty.typy": "Rodzaje etatów",
      "kadry.typy_godzin.lista": "Rodzaje godzin",
      "kadry.settings": "Inne ustawienia",
       "kadry.dni.wolne": "Dni wolne",
      "kadry.stawki": "Stawki",
   };

    const activeLabel = computed(() => {
      const current = route().current();
      return labels[current] || "Menu";
    });

    return {
      route,
      isRouteActive,
      isDropdownOpen,
      toggleDropdown,
      activeLabel,
    };
  },
};
</script>
